export default function(totalFat) {
  return {
    type:"SET_TOTAL_FAT",
    totalFat
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosTotals/setFatTotal.js